import { Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/**
 * Section heading in the settings panel — "How should we bring it in?", "Which pages?".
 *
 * These are pdf-to-figma's values, not an approximation of them: `2xs`, weight 500, muted,
 * `mb="1.5"`. Ours was `md` — roughly twice the size — with `mb="2.5"`, which is why the same
 * three questions filled a panel in illustrator that they half-fill in pdf. The plugin window
 * is 460x600; a heading at body size is a heading that costs a control.
 */
export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <Text mb="1.5" fontSize="2xs" fontWeight="500" color="figma.textMuted">
      {children}
    </Text>
  );
}
